import React from "react";
import { Switch } from "antd";

const SwitchAtivo = ({ checked, onChange }) => (
    <Switch checkedChildren="Ativos" unCheckedChildren="Inativos" defaultChecked checked={checked} onChange={onChange} />
);

export default SwitchAtivo;
